export function incompleteAction({landingPageId,cardDesignId,landscapeCardDesignId,portraitCardDesignId,printMode,printerGroupId}) {
 return !landingPageId || !(cardDesignId || landscapeCardDesignId || portraitCardDesignId) || (printMode !== 'none' && !printerGroupId);
}
